import { axios } from '@/utils/request'

const api = {
  Pre: '/index.php/Subscribe/pre',
  List: '/index.php/Subscribe/getList',
  SaveEvaluate: '/index.php/Subscribe/saveEvaluate',
  SaveKjpath: '/index.php/Subscribe/saveKjpath',
  SaveZwpath: '/index.php/Subscribe/saveZwpath',
  Feijiaobooktime: '/index.php/Subscribe/feijiaobooktime',
  Feijiaobookth: '/index.php/Subscribe/feijiaobookth',
  Oumeibooktime: '/index.php/Subscribe/oumeibooktime',
  Oumeibookth: '/index.php/Subscribe/oumeibookth',
  Zuowenbook: '/index.php/Subscribe/zuowenbook',
  // ChangePlan: '/index.php/Subscribe/changeplan',
  Yuyue: '/index.php/Subscribe/yuyue',
  Cancel: '/index.php/Subscribe/cancel',
  CheckProgress: '/index.php/Subscribe/checkProgress',
  SaveTopic: '/index.php/Subscribe/saveTopic'
}

// 预加载
export function getPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getList (parameter) {
  return axios({
    url: api.List,
    method: 'get',
    params: parameter
  })
}

export function saveEvaluate (parameter) {
  return axios({
    url: api.SaveEvaluate,
    method: 'post',
    data: parameter
  })
}

export function saveKjpath (parameter) {
  return axios({
    url: api.SaveKjpath,
    method: 'post',
    data: parameter
  })
}

export function saveZwpath (parameter) {
  return axios({
    url: api.SaveZwpath,
    method: 'post',
    data: parameter
  })
}

export function feijiaobooktime (parameter) {
  return axios({
    url: api.Feijiaobooktime,
    method: 'get',
    params: parameter
  })
}

export function feijiaobookth (parameter) {
  return axios({
    url: api.Feijiaobookth,
    method: 'get',
    params: parameter
  })
}

export function oumeibooktime (parameter) {
  return axios({
    url: api.Oumeibooktime,
    method: 'get',
    params: parameter
  })
}

export function oumeibookth (parameter) {
  return axios({
    url: api.Oumeibookth,
    method: 'get',
    params: parameter
  })
}

export function zuowenbook (parameter) {
  return axios({
    url: api.Zuowenbook,
    method: 'get',
    params: parameter
  })
}

export function yuYue (parameter) {
  return axios({
    url: api.Yuyue,
    method: 'post',
    data: parameter
  })
}

export function saveCancel (parameter) {
  return axios({
    url: api.Cancel,
    method: 'post',
    data: parameter
  })
}

export function checkProgress (parameter) {
  return axios({
    url: api.CheckProgress,
    method: 'get',
    params: parameter
  })
}

export function saveTopic (parameter) {
  return axios({
    url: api.SaveTopic,
    method: 'post',
    data: parameter
  })
}
